import { Coordinate, IGameServer, InitialResponse, SpinResponse } from "src/shared/util/Types";
import { GameState, GlobalState } from "src/shared/util/GlobalState";
import { observer } from "src/shared/util/Observer";
import { Connector } from "./Connector";
// import { SignalrClient } from "./SignalrClient";

export interface SymbolData {
  type: string;
  coordinates: Coordinate;
}

export class GameEngine {
  private static instance: GameEngine;
  private data!: SpinResponse;
  private loadResponse!: InitialResponse;

  public config = {
    reels: 5,
    rows: 3,
    isCascade: false,
    isMock: true,
    winType: "line",
  };
  protected formatter!: Intl.NumberFormat;
  protected client!: IGameServer;
  protected counter: number = 0;
  protected rig: string = "";

  constructor() {
    // Use EngineMock for testing purposes
    if (this.config.isMock) {
      this.client = new Connector();
    } else {
      // this.client = new SignalrClient("https://slotgamesapi.yogames.win/slots");
    }

    // Set up event listeners for initial state and game action results
    this.client.onInitialStateResult((data: InitialResponse) => {
      this.loadResponse = data;
      GlobalState.getInstance().updateState({ bet: data.bet ? data.bet : 1, balance: data.balance, state: data.state });
      observer.publish('initialStateResponse', data);
    });

    this.client.onGameActionResult((data: SpinResponse) => {
      this.data = data;
      console.log(this.data);
      let balance: number = data.balance || GlobalState.getInstance().balance;

      // Update balance based on game state and wins
      if (data.state === GameState.BONUS_TO_MAIN && data.totalWin) {
        balance += data.totalWin;
      } else if (data.roundWin && data.state === GameState.MAIN && data.wins.length === 0) {
        balance += data.roundWin;
      }
      GlobalState.getInstance().updateState({ balance, state: data.state });
      observer.publish('gameActionResponse', data);
    });


    observer.subscribe("rigSelected", (rig: string) => {
      this.rig = rig;
    });

    // Initialize number formatter
    this.formatter = new Intl.NumberFormat('en', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  // Public method to get the singleton instance
  public static getInstance(): GameEngine {
    if (!GameEngine.instance) {
      GameEngine.instance = new GameEngine();
    }
    return GameEngine.instance;
  }

  public getFormatter() {
    return this.formatter;
  }

  // Initialize the game engine
  public async init() {
    await this.client.getInitialState();
  }

  // Handle game action requests
  public gameActionRequest() {
    this.spin(this.rig);
    this.rig = ""; // Reset cheat after use
  }

  // Perform a spin action
  private spin(rig?: string) {
    this.client.gameAction(rig);
  }

  // Get the latest game response
  public getResponse() {
    return this.data;
  }

  // Get the initial load response
  public getLoadResponse() {
    return this.loadResponse;
  }
}
